module.exports = __webpack_public_path__ + "images/icons/icon-x-76c8e8e5.svg";